import React, { useEffect, useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import { Grid, makeStyles } from '@material-ui/core';
import styles from '../../Main/main.styles';
import axios from 'axios';
import { capitalize, isEmpty } from 'lodash';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import './editProfile.css';
import GirlImage from '../../images/girl.png';
import BoyImage from '../../images/boy.png';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import PersonalInfo from './components/PersonalInfo';
import Security from './components/Security';
import Devices from './components/Devices';
import Subscriptions from './components/Subscriptions';
import Notifications from './components/Notifications';
import Integrations from './components/Integrations';

const useStyles = makeStyles(styles);

const TAB_MENU = ['Personal Info', 'Security', 'Integrations'];

const TabContent = {
  'Personal Info': ({ user }) => <PersonalInfo user={user} />,
  Security: ({ user }) => <Security user={user} />,
  Integrations: ({ user }) => <Integrations user={user} />,
};

const CareRecipientDetailScreen = () => {
  const history = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);

  const getTabFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    return TAB_MENU.includes(tab) ? tab : TAB_MENU[0];
  };

  const [activeTab, setActiveTab] = useState(getTabFromUrl());

  useEffect(() => {
    const tab = getTabFromUrl();
    setActiveTab(tab);
  }, [location.search]);

  const ActiveTabComponent = TabContent[activeTab];

  const handleTabClick = (tab) => {
    history(`/edit-profile?tab=${tab}`);
    setActiveTab(tab);
  };

  return (
    <>
      <NewUserInfo />
      <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
        <Grid container className="tab-menu">
          {TAB_MENU.map((item, idx) => (
            <Grid
              key={idx}
              className="tab-menu-item"
              style={{ background: activeTab === item ? '#fff' : 'inherit' }}
              onClick={() => handleTabClick(item)}
            >
              {item}
            </Grid>
          ))}
        </Grid>

        {ActiveTabComponent && <ActiveTabComponent user={user} />}
      </div>

      <EmergencyButton />
    </>
  );
};

export default CareRecipientDetailScreen;
